import { useEffect, useState } from "react";
import {
  AGENDA_DESKTOP_MIN_PX,
  AGENDA_TABLET_MIN_PX,
  resolveAgendaViewport,
  type AgendaViewport,
} from "../agendaBreakpoints";

function readAgendaViewport(): AgendaViewport {
  if (typeof window === "undefined") {
    return "desktop";
  }
  return resolveAgendaViewport(window.innerWidth);
}

/** @deprecated Prefer AgendaViewport from useAgendaViewport */
export type AgendaLayoutMode = "wide" | "compact";

export function useAgendaViewport(): AgendaViewport {
  const [viewport, setViewport] = useState<AgendaViewport>(() =>
    readAgendaViewport()
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const mobileQuery = window.matchMedia(
      `(max-width: ${AGENDA_TABLET_MIN_PX - 1}px)`
    );
    const tabletQuery = window.matchMedia(
      `(min-width: ${AGENDA_TABLET_MIN_PX}px) and (max-width: ${
        AGENDA_DESKTOP_MIN_PX - 1
      }px)`
    );
    const desktopQuery = window.matchMedia(
      `(min-width: ${AGENDA_DESKTOP_MIN_PX}px)`
    );

    const sync = () => setViewport(readAgendaViewport());

    sync();
    mobileQuery.addEventListener("change", sync);
    tabletQuery.addEventListener("change", sync);
    desktopQuery.addEventListener("change", sync);
    window.addEventListener("resize", sync);

    return () => {
      mobileQuery.removeEventListener("change", sync);
      tabletQuery.removeEventListener("change", sync);
      desktopQuery.removeEventListener("change", sync);
      window.removeEventListener("resize", sync);
    };
  }, []);

  return viewport;
}

export function useAgendaLayoutMode(): AgendaLayoutMode {
  const viewport = useAgendaViewport();
  return viewport === "desktop" ? "wide" : "compact";
}

export function useAgendaIsDesktopSidebar(): boolean {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const media = window.matchMedia(`(min-width: ${AGENDA_DESKTOP_MIN_PX}px)`);
    const sync = () => setIsDesktop(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  return isDesktop;
}
